import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  Button,
  message,
  Input,
  Form,
  Select,
  Row,
  Col,
  DatePicker,
  Spin,
  Radio,
  Space,
} from "antd/lib";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ONBDetils } from "../../Redux/actions/OnboardAction";
import moment from "moment";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import "./onboard.css";
function ONBProfileEdit({ setCurrent, current }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { Option } = Select;
  const RemPass = useSelector((state) => state?.pass);
  const OTPData = useSelector((state) => state?.posp?.onboardOtp);
  const OnbNum = useSelector((state) => state?.posp?.Posp);
  const ONBDetails = useSelector((state) => state?.posp?.onbDetails);
  const [StateData, setStateData] = useState([]);
  const [email, setemail] = useState("");
  const [loading, setloading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  // console.log(OTPData);
  // let mount = false;

  useEffect(() => {
    // mount = true
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
    fetchStates();
  }, [current]);

  // const fetchStates = async () => {
  //   setloading(true);
  //   try {
  //     const res = await axiosInPosp
  //     .get(`v1/posp/profile/edit`);
  //     if (mount) {
  //       if (res?.status === 200) {
  //         const SData = res?.data?.states;
  //         setStateData(SData);
  //         const ProfData = res?.data?.profile;
  //         console.log("ProfData", ProfData);
  //         dispatch(ONBDetils(ProfData));
  //         form.setFieldsValue({
  //           firstName: ProfData?.first_name,
  //           lastname: ProfData?.last_name,
  //           email: ProfData?.email,
  //           dateofbirth: ProfData?.date_of_birth
  //             ? moment(ProfData?.date_of_birth, "DD-MM-YYYY")
  //             : null,
  //           gender: ProfData?.gender_id,
  //           address: ProfData?.address,
  //           city: ProfData?.city,
  //           state: ONBDetails?.state_id,
  //           pincode: ProfData?.pincode,
  //           // quote_request_from: ProfData?.quote_request_from,
  //         });
  //         setloading(false);
  //       }
  //     }
  //   }
  // }
  const fetchStates = () => {
    setloading(true);
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log(res);
        if (res?.status === 200) {
          const SData = res?.data?.states;
          setStateData(SData);
          const ProfData = res?.data?.profile;
          console.log("ProfData", ProfData);
          dispatch(ONBDetils(ProfData));
          form.setFieldsValue({
            firstName: ProfData?.first_name,
            lastname: ProfData?.last_name,
            email: ProfData?.email,
            dateofbirth: ProfData?.date_of_birth
              ? moment(ProfData?.date_of_birth, "DD-MM-YYYY")
              : null,
            gender: ProfData?.gender_id,
            address: ProfData?.address,
            city: ProfData?.city,
            state: ONBDetails?.state_id,
            pincode: ProfData?.pincode,
            // quote_request_from: ProfData?.quote_request_from,
          });
          setloading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const onNext = () => {
    setCurrent(current + 1);
  };
  // console.log("StateData", StateData);
  const handleSubmit = (values) => {
    console.log(values);
    const token = OnbNum?.accessToken;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let post = {
      name: values?.firstName,
      lastname: values?.lastname,
      email: values?.email,
      DateofBirth: moment(values?.dateofbirth).format("YYYY-MM-DD"),
      address: values?.address,
      gender: values?.gender,
      city: values?.city,
      state: values?.state,
      pincode: values?.pincode,
      // quote_request_from: values?.quote_request_from,
    };

    setloading(true);
    axios
      .patch(`${BaseUrl}v1/posp/profile`, post, { headers })
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        setloading(false);
        //dispatch(ONBDetils(Udata))
        setCurrent(current + 1);
      })
      .catch((err) => {
        console.log(err.response);
        // if (err.response.data.message === "Unauthenticated.") {
        //   dispatch({ type: "RESET_UAT" });
        // }
        setloading(false);
        //message.error('Invalid credentials!')
      });
  };

  return (
    <>
      {/* <div className="row justify-content-center h-100 align-items-center">
        <div className="right-section-on col-xl-7 col-lg-7 col-md-6 col-sm-12"> */}
      <div className="step-container">
        <div className="d-block text-center my-2">
          <h4 className="mb-2" style={{ color: "#00000069" }}>
            Profile Details
          </h4>
        </div>
        <Spin spinning={loading}>
          <Form
            onFinish={handleSubmit}
            form={form}
            requiredMark={false}
            layout="vertical"
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "please input Name",
                    },
                  ]}
                  //initialValue={ONBDetails?.first_name }
                >
                  <Input style={{ width: "100%" }} placeholder="Enter Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Last Name"
                  name="lastname"
                  rules={[
                    {
                      required: true,
                      message: "please input Name",
                    },
                  ]}
                  // initialValue={ONBDetails?.last_name}
                >
                  <Input style={{ width: "100%" }} placeholder="Enter Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email",
                    },
                  ]}
                  //initialValue={ONBDetails?.email}
                >
                  <Input
                    size="large"
                    // prefix={<UserOutlined />}
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                    placeholder="Enter Email"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Date of Birth"
                  name="dateofbirth"
                  rules={[
                    {
                      required: true,
                      message: "Please select DOB",
                    },
                  ]}
                  //initialValue={ONBDetails?.date_of_birth ? moment(ONBDetails?.date_of_birth) : null}
                >
                  <DatePicker
                    style={{ width: "100%", padding: "12px" }}
                    disabledDate={disabledDate}
                    defaultPickerValue={getDefaultPickerValue()}
                    format="YYYY-MM-DD"
                    //onChange={onDateChange}
                    placeholder="YYYY-MM-DD"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Gender"
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: "please input gender",
                    },
                  ]}
                >
                  <Radio.Group className="health-gender">
                    <Radio.Button value={1}>Male </Radio.Button>
                    <Radio.Button value={2}>Female </Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "please input Address",
                    },
                  ]}
                  //initialValue={ONBDetails?.address}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="Enter Address"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "please input city",
                    },
                  ]}
                  //initialValue={ONBDetails?.city}
                >
                  <Input style={{ width: "100%" }} placeholder="Enter City" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="State"
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "please input state",
                    },
                  ]}
                  // initialValue={ONBDetails?.state_id}
                >
                  <Select
                    placeholder="Select State"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    options={StateData.map((p) => ({
                      value: p.id,
                      label: p.state_name,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  rules={[
                    {
                      pattern: /^[0-9]{6}$/,
                      message: "Invalid pincode",
                    },
                    { required: true, message: "Enter pincode" },
                  ]}
                  //initialValue={ONBDetails?.pincode}
                >
                  <Input maxLength={10} placeholder="123456"></Input>
                </Form.Item>
              </Col>
              {/* <Col span={8}>
                <Form.Item
                  label="Agent Type"
                  name="quote_request_from"
                  rules={[
                    {
                      required: true,
                      message: "please select Agent type",
                    },
                  ]}
                  // initialValue={QuickPost?.quote_request_from}
                >
                  <Select placeholder="Select">
                    <Select.Option value="dealers">
                      Dealers/Subdealers
                    </Select.Option>
                    <Select.Option value="posp_outlet">Agents</Select.Option>
                    <Select.Option value="insur_comp">
                      Insurance Comp Employees
                    </Select.Option>
                    <Select.Option value="retail_outlet">
                      Retail Shops(Telecom,Groceries,Xerox,Petti Etc...,)
                    </Select.Option>
                    <Select.Option value="small_finance">
                      Small Finance/NBFC/CHIT Companies
                    </Select.Option>
                    <Select.Option value="e_commerce">E COMMERCE</Select.Option>
                    <Select.Option value="auto_shops">
                      Auto Shops(Workshops,Tyre,Batteries,Accessories Etc...,)
                    </Select.Option>
                    <Select.Option value="students">
                      Student/Others
                    </Select.Option>
                    <Select.Option value="franchis">
                      Franchise_Owners
                    </Select.Option>
                    <Select.Option value="chief_adv">
                      Chief Advisor
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col> */}
            </Row>

            <Row gutter={12} className="justify-content-center mb-2">
              <Col span={6}>
                <Form.Item className="step-btn-onb">
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Update
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item className="step-btn-onb">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => onNext()}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </div>
      {/* </div>
     </div> */}
    </>
  );
}

export { ONBProfileEdit };
